import { useEffect, useState } from 'react';
import ApiDatabase from 'server';
import UseContext from 'hooks/useContext';
import useModal from 'components/modal/useModal';

const HistoryContent = () => {
  const token = localStorage.getItem('xsrfToken');
  const { setModalData } = UseContext();
  const { toggle } = useModal();
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isWaiting, setIsWaiting] = useState(true);
  const [typeFilter, setTypeFilter] = useState('');

  const fetchHistory = () => {
    setIsWaiting(true);
    ApiDatabase.getPayslipImportHistory(
      { token, page, limit: 20 },
      (data) => {
        setLogs(data.logs || []);
        setTotalPages(data.totalPages || 0);
        setIsWaiting(false);
      },
      (err) => {
        if (err.name !== 'CanceledError') console.log(err);
        setIsWaiting(false);
      }
    );
  };

  useEffect(() => {
    fetchHistory();
  }, [page]);

  useEffect(() => {
    setPage(1);
  }, [typeFilter]);

  const filteredLogs = typeFilter
    ? logs.filter((log) => {
        if (typeFilter === 'payslip') return log.action === 'imported' || log.action === 'removed';
        if (typeFilter === 'invoice') return log.action === 'invoice_imported' || log.action === 'invoice_removed';
        return true;
      })
    : logs;

  const statusLabel = (status) => {
    const map = {
      pending: 'En attente',
      processing: 'En cours',
      completed: 'Terminé',
      failed: 'Échoué',
    };
    return map[status] || status;
  };

  const statusColor = (status) => {
    const map = {
      pending: 'text-yellow-600',
      processing: 'text-blue-600',
      completed: 'text-green-600',
      failed: 'text-red-600',
    };
    return map[status] || '';
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <h3 className="text-sm font-semibold text-gray-700">
          Historique des actions
        </h3>
        <select
          className="h-9 pl-2 pr-3 border rounded-lg text-sm"
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
        >
          <option value="">Tous</option>
          <option value="payslip">Fiches de paie</option>
          <option value="invoice">Factures client</option>
        </select>
      </div>
      {isWaiting ? (
        <div className="animate-pulse space-y-2">
          {[1, 2, 3, 4, 5].map((_, i) => (
            <div key={i} className="h-8 bg-gray-100 rounded" />
          ))}
        </div>
      ) : filteredLogs.length === 0 ? (
        <p className="text-sm text-gray-400">Aucun historique.</p>
      ) : (
        <>
          <table className="w-full text-sm border rounded">
            <thead className="bg-gray-50">
              <tr>
                <th className="p-2 text-left">Date</th>
                <th className="p-2 text-left">Admin</th>
                <th className="p-2 text-left">Action</th>
                <th className="p-2 text-right">Total</th>
                <th className="p-2 text-right">Succès</th>
                <th className="p-2 text-right">Échoué</th>
                <th className="p-2 text-right">Montant</th>
                <th className="p-2 text-left">Statut</th>
              </tr>
            </thead>
            <tbody>
              {filteredLogs.map((log) => (
                <tr
                  key={log._id}
                  className="border-t border-gray-100 hover:bg-gray-50 cursor-pointer"
                  onClick={() => {
                    setModalData({ logId: log._id });
                    toggle('payslip_import_detail');
                  }}
                >
                  <td className="p-2">
                    {log.timestamp
                      ? new Date(log.timestamp).toLocaleString('fr-FR')
                      : '-'}
                  </td>
                  <td className="p-2">
                    {log.idEmployee?.firstname} {log.idEmployee?.lastname}
                  </td>
                  <td className="p-2">
                    {log.action === 'imported' ? 'Import' : 'Suppression'}
                  </td>
                  <td className="p-2 text-right">{log.summary?.total || 0}</td>
                  <td className="p-2 text-right">
                    {log.summary?.success || 0}
                  </td>
                  <td className="p-2 text-right">
                    {log.summary?.failed || 0}
                  </td>
                  <td className="p-2 text-right">
                    {log.summary?.totalAmount != null
                      ? `${Number(log.summary.totalAmount).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
                      : '-'}
                  </td>
                  <td className={`p-2 font-medium ${statusColor(log.status)}`}>
                    {statusLabel(log.status)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {totalPages > 1 && (
            <div className="flex gap-2 justify-center text-sm">
              <button
                className="px-3 py-1 border rounded disabled:opacity-50"
                disabled={page <= 1}
                onClick={() => setPage((p) => p - 1)}
              >
                Précédent
              </button>
              <span className="px-3 py-1">
                {page} / {totalPages}
              </span>
              <button
                className="px-3 py-1 border rounded disabled:opacity-50"
                disabled={page >= totalPages}
                onClick={() => setPage((p) => p + 1)}
              >
                Suivant
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default HistoryContent;
